import { useConfirm } from 'primevue/useconfirm';
import type { ConfirmationOptions } from 'primevue/confirmationoptions';

export function useConfirmDialog() {
  const confirm = useConfirm();

  const confirmDelete = (options: ConfirmationOptions): void => {
    confirm.require({
      rejectLabel: 'Cancelar',
      acceptLabel: 'Excluir',
      acceptClass: 'p-button-danger',
      ...options,
    });
  };

  return {
    confirm,
    confirmDelete,
  };
}
